module.exports = __webpack_public_path__ + "static/img/jiat-innovation02.00e465f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/jiat-innovation02.jpg
// module id = I3G8
// module chunks = 0